import { ElDatePicker } from 'element-plus';

export default {
   
    setCookie(cname, cvalue, exdays = 30) {
      const d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      let expires = "expires="+d.toUTCString()
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    },
    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ""
    },
    btoa(dat) {
      return Buffer.from(dat, 'binary').toString('base64');
    },
    
    getDate(date = null, format = 'yyyy-MM-dd'){
      date ??= new Date()
      return ElDatePicker.props.formatDate(date, format)
    }

}